export const normalizeLitigationDateLayout = (startDate, endDate, isDependantDate = false) => {
  const usesStartDate = Boolean(startDate);
  const usesEndDate = Boolean(endDate);

  if (usesStartDate && !usesEndDate) {
    return {
      start_date: true,
      end_date: false,
      is_dependant_date: true,
    };
  }

  if (!usesStartDate && usesEndDate) {
    return {
      start_date: false,
      end_date: true,
      is_dependant_date: false,
    };
  }

  if (!usesStartDate && !usesEndDate) {
    return {
      start_date: true,
      end_date: true,
      is_dependant_date: false,
    };
  }

  return {
    start_date: true,
    end_date: true,
    is_dependant_date: Boolean(isDependantDate),
  };
};

export const updateLitigationDateLayout = (form, changes) => {
  const nextForm = { ...form, ...changes };
  return {
    ...nextForm,
    ...normalizeLitigationDateLayout(
      nextForm.start_date,
      nextForm.end_date,
      nextForm.is_dependant_date
    ),
  };
};

export const getDependantEndpoint = (configuration) =>
  configuration?.is_dependant_date ? "start_date" : "end_date";

export const getDateEndpointLabel = (configuration, endpoint, dependantTypeLabel = "") => {
  const isDependantEndpoint = getDependantEndpoint(configuration) === endpoint;

  // if (isDependantEndpoint) {
  //   return dependantTypeLabel || "Dependant Date";
  // }

  if (endpoint === "start_date") {
    return (
      configuration?.start_date_label ||
      dependantTypeLabel ||
      (isDependantEndpoint ? "Dependant Date" : "Start Date")
    );
  }

  return (
    configuration?.end_date_label ||
    dependantTypeLabel ||
    (isDependantEndpoint ? "Dependant Date" : "End Date")
  );
};

export const getUsesStartDate = (configuration) =>
  Boolean(configuration?.uses_start_date ?? configuration?.start_date);

export const getUsesEndDate = (configuration) =>
  Boolean(configuration?.uses_end_date ?? configuration?.end_date);

export const addLitigationDays = (date, dayCount, dayType) => {
  const days = parseInt(dayCount, 10) || 0;

  if (!days) {
    return date;
  }

  const isCourtDay = String(dayType || "")
    .trim()
    .toLowerCase()
    .includes("court");

  if (!isCourtDay) {
    date.setDate(date.getDate() + days);
    return date;
  }

  const direction = days < 0 ? -1 : 1;
  let remainingDays = Math.abs(days);

  while (remainingDays > 0) {
    date.setDate(date.getDate() + direction);

    const dayOfWeek = date.getDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (!isWeekend) {
      remainingDays -= 1;
    }
  }

  return date;
};

import SOLicon from "../assets/litigation/sol.svg";

export const EventTypeIcon = ({ name }) => {
  if (name === "Statute of Limitations") {
    return (
      <img
        src={SOLicon}
        alt=""
        className="ic-15 m-r-5"
        style={{
          minWidth: "15px",
          maxWidth: "15px",
          minHeight: "15px",
          maxHeight: "15px",
        }}
      />
    );
  }

  const iconClass =
    name === "Discovery"
      ? "ic-discovery"
      : name === "Statute of Limitation" || name === ""
        ? "ic-SOL"
        : name === "Expert Discovery"
          ? "ic-Expert-Discovery"
          : name === "Case Initiation"
            ? "ic-Case-Initiation"
            : name === "Mediation / Arbitration"
              ? "ic-Mediation-Arbitration"
              : name === "Settlement Conference"
                ? "ic-Settlement-Conference"
                : "ic-" + name;

  return (
    <i
      className={`ic ic-15 ${iconClass} m-r-5`}
      style={{
        minWidth: "15px",
        maxWidth: "15px",
        minHeight: "15px",
        maxHeight: "15px",
      }}
    />
  );
};
